import api from './api'

const BASE = '/admin/catalog'

export default {
  /** Offres et add-ons de la plateforme avec leurs prix (USD), inactifs compris. */
  async list() {
    const { data } = await api.get(`${BASE}/`)
    return data.data
  },

  /** Prix d'une offre : { price_monthly, price_annual } (annuel = prix PAR MOIS). Odoo est prevenu. */
  async updatePlan(id, payload) {
    const { data } = await api.patch(`${BASE}/plans/${id}`, payload)
    return data.data
  },

  /** Prix d'un add-on : { price_monthly, price_annual }. Odoo est prevenu. */
  async updateAddon(id, payload) {
    const { data } = await api.patch(`${BASE}/addons/${id}`, payload)
    return data.data
  },
}
